module.exports = __webpack_public_path__ + "img/filter-list-view.45554be5.svg";